// extracted by mini-css-extract-plugin
export default {"wrapper":"View_wrapper__RGg6b","title":"View_title__7OwTL"};